import { Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SAMPLE_STORAGE_SETUP_HREF } from '../../utils/sampleStorageSetupGate';

type SampleNeedsStorageSetupAlertProps = {
  className?: string;
};

/**
 * 帳票・使用履歴など「ハード redirect しない」面向けの保管庫ゼロ案内。
 * 一覧／ケースは Navigate ゲートが正。こちらはナビ直打ち用のソフト導線。
 */
export default function SampleNeedsStorageSetupAlert({
  className = 'mb-2',
}: SampleNeedsStorageSetupAlertProps) {
  const { t } = useTranslation();
  return (
    <Alert variant="info" className={className}>
      <Alert.Heading as="h2" className="h6 mb-2">
        {t('storage_room.setup_banner_title', {
          defaultValue: 'はじめに · 保管庫の登録',
        })}
      </Alert.Heading>
      <p className="mb-2 small">
        {t('sample.list_empty_needs_storage', {
          defaultValue: 'サンプルを登録する前に、保管庫を1つ登録してください。',
        })}
      </p>
      <Button as={Link as any} to={SAMPLE_STORAGE_SETUP_HREF} variant="primary" size="sm">
        <i className="fas fa-warehouse me-1" aria-hidden="true" />
        {t('sample.list_empty_go_to_storage', {
          defaultValue: '保管庫を登録する',
        })}
      </Button>
    </Alert>
  );
}
